import { render, staticRenderFns } from "./integralCategories.vue?vue&type=template&id=4f15b472"
import script from "./integralCategories.vue?vue&type=script&lang=js"
export * from "./integralCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports